// extracted by mini-css-extract-plugin
export var megalist = "index-module--megalist--36f28";
export var megamenu = "index-module--megamenu--fa5f5";
export var navdesktop = "index-module--navdesktop--2e69b";